// extracted by mini-css-extract-plugin
export var shake = "_7-0";